var exports = {
  "B": "dateFieldsMenuOverlay__6d6hVP",
};

module.exports = exports;
